<template>
  <div class="category-management">
    <a-button type="primary" style="float: right;" @click="showAddCategoryModal">新增首页飘窗设置</a-button>

    <!-- 分类列表：分页显示 -->
    <a-table :dataSource="categories" :columns="categoryColumns" rowKey="id" :pagination="false"
      style="margin-top: 20px;">
      <template v-slot:bodyCell="{ column, record, index }">
        <template v-if="column.key === 'sn'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key == 'name'">
          {{ record.name }}
        </template>
        <template v-if="column.key === 'parentId'">
          {{ getParentCategoryName(record.parentId) }}
        </template>
        <template v-if="column.key === 'operation'">
          <a-space>
            <a href="javascript:;" @click="editModal(record)">修改</a>

          </a-space>
        </template>
      </template>
    </a-table>

    <!--  模态框 -->
    <a-modal v-model:visible="visible" title="操作" @ok="handleSave" @cancel="handleCategoryCancel">
      <a-form :label-col="labelCol" :rules="rules" ref="formRef" :model="form">



        <a-form-item label="名称" name="title" ref="title">
          <a-input v-model:value="form.title" placeholder="请输入名称" />
        </a-form-item>
        <a-form-item label="链接地址" name="linkUrl" ref="linkUrl">
          <a-input v-model:value="form.linkUrl" placeholder="请输入链接地址" />
        </a-form-item>
        <a-col :span="12">
          <a-form-item label="飘窗图片">
            <file-upload ref="NewsFileUpload" :maxLength="1" :fileList="form.cardImageFiles" :relationId="form.id"
              relationModule="ConfigPhotoFiles" fileType="image" uploader="admin" :isMultiple="false"
              @upload-complete="filesPhotosComplete" @del-file="NewsPhotosDel" @add-file="newsPhotosAdd" />
          </a-form-item>
        </a-col>
        <a-form-item label="是否显示" name="isShow" ref="isShow">
          <a-radio-group v-model:value="form.isShow" name="radioGroup" :options="status" />
        </a-form-item>


      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, toRaw, watch, getCurrentInstance,nextTick } from 'vue';
import http from '@/shared/http.service';
import { Uris } from '@/shared/const';
import { Table, Space, Button, Popconfirm, Modal, Form, Input, Select } from 'ant-design-vue';
import fileUpload from '@/components/file.upload.vue';
import { FileAddOutlined, } from '@ant-design/icons-vue';
import { withWarn } from 'ant-design-vue/es/modal/confirm';
import useBaseConfig from '@/composables/useBaseConfig';
const formRef = ref();
const instance = getCurrentInstance();

const {
  form,
  isAdd,
  saved$,
  handleSave,
} = useBaseConfig();

const status = [
  { value: 1, label: "是", checked: true },
  { value: 0, label: "否" },
];

const visible = ref(false); // 模态框显示/隐藏

const value = ref();
const categories = ref([]); // 分类列表 
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
}); // 分页配置

const labelCol = { style: { width: '90px' } }; // 表单label宽度

watch(value, () => {
  console.log("value" + value.value);
});
// 获取分类列表（包括分页）
const fetchCategories = async () => {
  try {
    // {params: { pageIndex: page, pageSize: pagination.pageSize },}

    http.get(Uris.BaseConfigList, {}).subscribe(result => {
      // 处理后端返回的数据
      // 更新分类列表
      categories.value = result;
    });

  } catch (error) {
    console.error('Error fetching categories', error);
  }
};

//图片上传成功后
const newsPhotosAdd = (result) => {
  // console.log(result)
  form.cardImageFiles = instance.refs.NewsFileUpload.fileAttachments;

};

// 删除图片
const NewsPhotosDel = (file) => {

  form.cardImageFiles = instance.refs.NewsFileUpload.fileAttachments;
  let index = form.cardImageFiles.findIndex(item => item.uid === file.uid);
  if (index !== -1) {
    form.cardImageFiles.splice(index, 1);
  }
};


// 获取上级分类名称
const getParentCategoryName = (parentId) => {
  const category = categories.value.find((cat) => cat.id === parentId);
  return category ? category.name : '无';
};

// 分页变化处理
const handleTableChange = () => {

  fetchCategories();
};



const getKeyId = async () => {
  await http.get(Uris.GetId).subscribe(result => {
    rid.value = result;
    form.id = result;
  });
};
// 新增分类
const showAddCategoryModal = () => {
  form.id = null;
  form.title = '';
  form.isShow = 1;
  if (instance.refs.NewsFileUpload) {
    instance.refs.NewsFileUpload.fileAttachments = [];
  }
  getKeyId();
  isAdd.value = true;
  visible.value = true;
};


const editModal = (requestModel) => {
  isAdd.value = false;
  console.log(requestModel);
  rid.value = requestModel.id;
  http.get(Uris.GetBaseConfig, { id: requestModel.id }).subscribe(v => {
    if (v) {
      form.id = v.id;
      form.title = v.title;
      form.isShow = v.isShow;
      form.linkUrl = v.linkUrl;
      form.cardImageFiles = v.cardImageFiles ? v.cardImageFiles : [];
      visible.value = true;
    }
  });
};


// 提交分类操作（新增或编辑）
const handleCategorySubmit = () => {
  // 表单验证
  formRef.value.validate().then(() => {
    try {
      if (!isAdd.value) {
        http.post(Uris.PutBaseConfig, form).subscribe(t => {
          visible.value = false;
        });
      } else {
        http.post(Uris.PostBaseConfig, form).subscribe(t => {

          visible.value = false;
        });
      }
    } catch (error) {
      console.error('Error submitting category', error);
    }
  })
    .catch(error => {
      console.log('error', error);
    });
};

// 取消操作
const handleCategoryCancel = () => {
  visible.value = false;
  formRef.value.resetFields();
};



const rid = ref();
//文件上传完成后的事件处理
const filesPhotosComplete = (result) => {
  console.log(result);
  if (result) {
    if (result.files.length > 0) {
      const url = result.files[0].url;
      const requestModel = {
        imageUrl: url,
        id: rid.value
      };
      http.put(Uris.PutBaseConfig, requestModel).subscribe((retrunresult) => {

      });
    }

  }
  form.cardImageFiles = [];
  // if (type.value == 'add') {
  //   showModal();
  // }
};


const saved = async (result) => { 
  if (instance.refs.NewsFileUpload.fileAttachments?.length > 0 || instance.refs.NewsFileUpload.removedAttachments?.length > 0) {
    //新闻图片上传
    await nextTick(() => {
      instance.refs.NewsFileUpload.uploadFile();
    }).finally(() => {

      fetchCategories();
    });
  }
 
};



// 初始化
onMounted(() => {
  fetchCategories();
  saved$.subscribe(async (result) => { 
    visible.value = false;
    saved(result);
   
  });
});


const rules = {
  title: [
    {
      required: true,
      message: '请输入名称',
      trigger: 'change',
    },
  ]
};

// 表格列配置
const categoryColumns = [
  {
    title: '序号',
    dataIndex: 'sn',
    key: 'sn',
    width: 200,
    align: 'center',
  },
  {
    title: '名称',
    width: 200,
    dataIndex: 'title',
    key: 'title',
    align: 'center',
  },
  {
    title: '链接地址',
    width: 200,
    dataIndex: 'linkUrl',
    key: 'linkUrl',
    align: 'center',
  },
  {
    title: '是否显示',
    width: 200,
    dataIndex: 'isShow',
    key: 'isShow',
    align: 'center',
    customRender: ({ record }) => `${record.isShow === 1 ? "显示" : "不显示"}`,
  },
  {
    title: '操作',
    width: 200,
    key: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
  },
];
</script>

<style scoped>
p {
  padding-left: 20px;
}
</style>